(function listHubTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const configurations = {
  };

  const previousModule = global.NewHomeSource.Analytics.ListHubTracker;
  const trackListHubSrc = '//tracking.listhub.net/scripts/la.min.js';
  /**
   ** load the trackListHub file if it hasn't been loaded before.
   */
  function loadScriptListHub() {
    const isTrackListHubLoaded = document.querySelector(`[src="${trackListHubSrc}"]`);

    if (isTrackListHubLoaded) {
      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = trackListHubSrc;
    scriptTag.async = 'true';
    scriptTag.type = 'text/javascript';
    document.documentElement.appendChild(scriptTag);
  }

  /**
   * log event for listHubTracker
   */
  function logEvent(event, element) {
    const listHubProviderId = element.dataset.providerId;
    const testkey = element.dataset.testLogging;
    const listingKey = element.dataset.listingNumber;
    const lh = new global.ListHubTracker({
      provider: listHubProviderId,
      test: testkey
    });
    lh.submit(event, listingKey);
  }

  /**
   ** @constructs NewHomeSource.Analytics.ListHubTracker
   */
  function ListHubTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  /**
   * send the received event.
   * @returns false if the event has not been loaded or true if already.
   */
  ListHubTracker.eventTracker = function () {
    if (!global.ListHubTracker) {
      loadScriptListHub();
      return false;
    }
    const event = this.dataset.eventLh;
    logEvent(event, this);
    return true;
  };

  /**
    * @public
    * impressionTrackerSelector: returns the expression that can be used to query the DOM for impression events.
    */
  ListHubTracker.impressionTrackerSelector = function () {
    return 'data-impresion-lh-event';
  };

  /**
     * @public
     * impressionTracker: send data related to display events.
     *
     * @param {object} status of the scheduled idle task.
     */
  ListHubTracker.impressionTracker = function () {
    if (!global.ListHubTracker) {
      loadScriptListHub();
      return false;
    }
    this.forEach((element) => {
      const data = element.dataset;
      const event = data.impresionLhEvent;
      logEvent(event, element);
    });
    return true;
  };

  ListHubTracker.eventTrackerValidator = function (dataSet) {
    if (dataSet.eventLh) {
      return true;
    }

    return false;
  };

  /**
     * @public
     * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
     */
  ListHubTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.ListHubTracker = previousModule;
    return ListHubTracker;
  };

  global.NewHomeSource.Analytics.ListHubTracker = ListHubTracker;
  return ListHubTracker;
}(window));
